"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SceneLoader {
    constructor(game, sceneKey) {
        this.game = game;
        this.sceneDescription = game.cache.json.get(sceneKey);
    }
    loadScene() {
        this.game.load.image(this.sceneDescription.bg_image_name, ["./assets/backgrounds/" + this.sceneDescription.bg_image_name, "./assets/lm.png"]);
        this.game.load.audio(this.sceneDescription.bg_music_name, "./assets/music/" + this.sceneDescription.bg_music_name);
        this.loadConversationNode(this.sceneDescription.conversationTree);
        return this.sceneDescription;
    }
    loadConversationNode(node) {
        this.game.load.audio(node.audio_file_name, "./assets/sounds/" + node.audio_file_name);
        if (node.options == null) {
            return;
        }
        for (let option of node.options) {
            for (let node1 of option.nodes) {
                this.loadConversationNode(node1);
            }
        }
    }
}
exports.SceneLoader = SceneLoader;
